import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireComponent, UmpireComponentType} from '@tisa-group/models';
import {Observable} from 'rxjs';

import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class ComponentService
  implements CrudService<UmpireComponent<UmpireComponentType>>
{
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireComponent<UmpireComponentType>>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponent<UmpireComponentType>>> {
    return this.http
      .post(`/components`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/components/${id}`);
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponent<UmpireComponentType>>> {
    return this.http
      .get(`/components/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireComponent<UmpireComponentType>>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponent<UmpireComponentType>>> {
    return this.http
      .patch(`/components/${body?.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponent<UmpireComponentType>[]>> {
    return this.http
      .get(`/components`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
